import React, { useContext, useEffect, useState } from "react";
import Icon from "./Detail/Icons";
import { StoreContext } from "../context/context";
import { useTranslation } from "../context/TranslationContext";

const FavBtn = ({ className, hideText, data, inlineclass }) => {
  const { addFavourite, removeFavourite } = useTranslation();
  const { favourites, setFavourites } = useContext(StoreContext);
  const [isAdded, setIsAdded] = useState(false);
  useEffect(() => {
    setIsAdded(favourites.find((x) => x.id == data.id) ? true : false);
    localStorage.setItem("Favourites", JSON.stringify(favourites));
  }, [favourites]);

  const HandClick = (e) => {
    const result = favourites.findIndex((x) => x.id == data.id);
    let a = [...favourites];

    if (result > -1) {
      a.splice(result, 1);
      setFavourites(a);
    } else {
      setFavourites([...favourites, data]);
    }
  };

  return (
    <button
      className={className}
      type="button"
      onClick={HandClick}
      aria-label="Favori"
    >
      <span
        className={
          (inlineclass
            ? inlineclass
            : "w-10 h-10 rounded-full   p-2.5 bg-white  transition-colors ") +
          (isAdded ? "text-red-600" : "text-heart-bg")
        }
      >
        <Icon name={"heart"}></Icon>
      </span>
      {!hideText && (
        <span className="font-bold text-xxs text-brand-black -mt-3">
          {isAdded ? removeFavourite : addFavourite}
        </span>
      )}
      <div className="inner"></div>
    </button>
  );
};

export default React.memo(FavBtn);
